import React from 'react';
import { Paper, Typography, Box, Grid } from '@mui/material';

const QuoteReview = () => {
  const quoteDetails = {
    vehicleInfo: {
      year: "2024",
      make: "Dodge/RAM",
      model: "Hornet GT",
      bodyStyle: "Small-Medium SUV",
      fuelType: "Gasoline",
      condition: "New",
      winterTires: "Yes",
    },
    coverage: {
      liability: {
        limit: "$2,000,000",
        premium: "$745"
      },
      directCompensation: {
        deductible: "$0",
        premium: "$1,118"
      },
      collision: {
        deductible: "$1,000"
      },
      comprehensive: {
        deductible: "$1,000"
      },
      uninsuredAutomobile: {
        premium: "$47"
      },
      additionalCoverage: [
        "OPCF 20: Loss of Use ($2,000)",
        "OPCF 27: Liability for Non-Owned Vehicle ($75,000 limit)",
        "OPCF 43: Limited Waiver of Depreciation (24 months)",
        "OPCF 44: Family Protection ($2,000,000)"
      ]
    },
    totalPremium: "$4,738"
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Quote Summary
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
              Vehicle Details
            </Typography>
            <Box sx={{ pl: 2 }}>
              <Typography>Vehicle: {quoteDetails.vehicleInfo.year} {quoteDetails.vehicleInfo.make} {quoteDetails.vehicleInfo.model}</Typography>
              <Typography>Body Style: {quoteDetails.vehicleInfo.bodyStyle}</Typography>
              <Typography>Fuel Type: {quoteDetails.vehicleInfo.fuelType}</Typography>
              <Typography>Condition: {quoteDetails.vehicleInfo.condition}</Typography>
              <Typography>Winter Tires: {quoteDetails.vehicleInfo.winterTires}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
              Coverage Details
            </Typography>
            <Box sx={{ pl: 2 }}>
              <Typography>Liability: {quoteDetails.coverage.liability.limit}</Typography>
              <Typography>Direct Compensation Deductible: {quoteDetails.coverage.directCompensation.deductible}</Typography>
              <Typography>Collision Deductible: {quoteDetails.coverage.collision.deductible}</Typography>
              <Typography>Comprehensive Deductible: {quoteDetails.coverage.comprehensive.deductible}</Typography>
            </Box>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>
              Additional Coverage
            </Typography>
            <Box sx={{ pl: 2 }}>
              {quoteDetails.coverage.additionalCoverage.map((coverage, index) => (
                <Typography key={index}>• {coverage}</Typography>
              ))}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ 
            mt: 2, 
            p: 2, 
            bgcolor: '#f8f9fa', 
            borderRadius: 1,
            border: '1px solid #e0e0e0'
          }}>
            <Typography variant="h6" color="primary">
              Total Annual Premium: {quoteDetails.totalPremium}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default QuoteReview; 